import { cn } from '@qr-front/ui/utils'
import {
	frameBackgroundColorAtom,
	frameColorAtom,
	frameTextAtom,
	frameTextColorAtom,
	frameTypeAtom,
} from 'features/generator/pages/QrDesignFormPage/FrameDesignForm'
import { qrBackgroundColorAtom } from 'features/generator/pages/QrDesignFormPage/PatternDesignForm'
import { FRAME_TYPE_OPTION_LIST } from 'features/generator/qrFrames'
import { useAtomValue } from 'jotai'

import { CONTRAST_BACKGROUND_COLOR } from '../qrImageBuilder'
import { useFrameFontSize } from '../utils/useFrameFontSize'

type TQrImageWithFrameProps = {
	patternMarkup: string
	size?: number
	className?: string
	isWhite?: boolean
}

export const ImageWithFrame = ({
	isWhite = false,
	patternMarkup,
	size,
	className,
}: TQrImageWithFrameProps) => {
	const frameType = useAtomValue(frameTypeAtom)
	const text = useAtomValue(frameTextAtom)
	const frameColor = useAtomValue(frameColorAtom)
	const textColor = useAtomValue(frameTextColorAtom)
	const frameBackgroundColor = useAtomValue(frameBackgroundColorAtom)
	const patternBackgroundColor = useAtomValue(qrBackgroundColorAtom)

	const selectedFrameOption = FRAME_TYPE_OPTION_LIST.find(
		({ value }) => value === frameType,
	)

	const frameFontSize = useFrameFontSize({
		text,
		maxWidth: selectedFrameOption?.customMaxWidth,
		maxSize: selectedFrameOption?.customMaxFontSize,
		fontFamily: selectedFrameOption?.customFontFamily,
	})

	const Frame = selectedFrameOption?.Frame

	if (!Frame) {
		return null
	}

	return (
		<div
			className={cn(
				'[&>svg]:w-[var(--qr-frame-size)] [&_*]:transition-none',
				className,
			)}
			style={{ '--qr-frame-size': size ? `${size}px` : undefined }}
		>
			<Frame
				previewMode={false}
				patternMarkup={patternMarkup}
				text={text}
				fontSize={frameFontSize}
				frameColor={frameColor}
				textColor={textColor}
				frameBackgroundColor={frameBackgroundColor}
				patternBackgroundColor={
					isWhite ? CONTRAST_BACKGROUND_COLOR : patternBackgroundColor
				}
			/>
		</div>
	)
}
